module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAABB0lEQVRYhc2YsQ3CMBBF01BE2CkpYABmYAVWYAZWYAXqlCD5ipQUNqAICTEDK7ACDRIYqthWUGJffP7S1f/J8vfdOcsiikux5BKuXImXrjqvq1k8cyUWTMGBK3gbJeESwbyaMwk7x7xRg5mPT/sJU2L7z3w4iLIcMSk2+pifXQDQIQoJa23+6GqOClEcxUpfvHtfcxSIX9wU3HzNgyBa4xYDokvcBoPoEzd8CI+4oUL4xg0FIjRuQRD5GaYcIW5BEN+2SgFgQdAApHcSSdyJJNKR1DthiPrFbIq2d1gi7aIuDOE84cBQTla2SGdMB4Zy2jZEvXc0RbuBWSLdRV0Ywq3cgWn5n/gAgLzanbHt+yoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/back.png
// module id = uR+e
// module chunks = 1